import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  order: 6;
  background: var(--Shades-50, #f0f0f5);
  padding: 20px 24px 40px 24px !important;
  margin: 0px !important;
  padding: 40px 0px !important;
  margin-top: 100px !important;

  ${media.md`
    padding: 60px 44px !important;
    gap: 40px;
  `}

  ${media.lg`
    padding: 75px 80px !important;
    gap: 20px;
  `}
`;

export const StyledContentBlock = styled.div`
  padding: 0px !important;
  margin: auto;
  flex-direction: column;
  display: flex;
  gap: 20px;
`;

export const Title = styled.h2`
  color: var(--Grey-Scale-900, #1c1c1c);
  align-self: stretch;
  padding: 0px 20px;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 34px;
  font-style: normal;
  font-weight: 900;
  line-height: 85%; /* 81px */
  letter-spacing: -0.68px;
  text-transform: uppercase;
  display: flex;
  margin: 0px 0px 40px 0px;
  margin-bottom: 0px;

  ${media.md`
    font-size: 60px;
    line-height: 90%;
    letter-spacing: -1.2px;
    margin: 0px 0px 20px 0px;
    padding:unset;
  `}
  ${media.lg`
    font-size: 60px;
    line-height: 90%;
    letter-spacing: -1.2px;
    margin: 0px 0px 40px 0px;
    padding:unset;
  `}
`;

export const InlineLink = styled.a`
  color: inherit;
  text-decoration: underline;
  font: inherit;
  text-underline-offset: 4px;
`;

export const FAQItem = styled.div`
  border-bottom: 1px solid var(--Shades-100, #c5c2cc);
  overflow: hidden;
  transition: all 0.3s ease;
  padding-bottom: 10px;
  gap: var(--radius-xsml, 10px);
  align-self: stretch;
  align-items: flex-start;
  padding-left: 20px;
  padding-right: 20px;
  ${media.md`
    padding: 10px 0px 22px 0px;
  `}
`;

export const FAQHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
`;

export const FAQContent = styled.div<{ isExpanded: boolean }>`
  max-height: ${props => (props.isExpanded ? '500px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;

  ${props =>
    props.isExpanded &&
    `
    
    
   
  `}
`;

export const ToggleIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease;

  svg {
    width: 30px;
    height: 30px;
  }
`;

export const Sectiontitle = styled.p`
  color: var(--Shades-900, #1c1c1c);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
  margin: 0px;

  ${media.md`
    font-size: 18px;
    line-height: 150%;
  `}
`;

export const SectionContent = styled.p`
  color: var(--Shades-700, #67656e);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
  margin: 0px;
  padding-top: 16px;

  ${media.md`
    font-size: 16px;
  `}
`;

export const Icon = styled.img`
  width: 30px;
  height: 30px;
`;

export const Container = styled.div`
  display: flex;
  height: 50px;
  padding: 10px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-xsml, 10px);
`;
